import restClient from 'Shared/hooks/restClient'
import ServerWaitButton from 'Shared/components/ServerWaitButton'
import useActionTranslate from 'FlowBuilder/hooks/useActionTranslate'
import ActionTextContentField from '../ActionTextContentField'
import FlowTextContentField from '../FlowTextContentField'

export default function LookupDecisionMakers({ decisionMakerSet, setDecisionMakers, action, onSkip, setLoading, setPostcode, hasReset, autoLookup }) {
  const flowId = useSel(s => s.taker?.flow?.id || s.builder.flow.id)
  const [localPostcode, setLocalPostcode] = useState('')
  const [error, setError] = useState(null)
  const postcodeDetailsPresent = useSel(s => s.taker?.targetDetails?.detailsPresent?.postcode || false)
  const { fallback: { enterYourPostcodePlaceholder, noDecisionMakersFoundMessage, invalidLookupValidationMessage, otherLookupErrorMessage } } = useActionTranslate({ actionId: action.id })
  const isPreview = useSel(s => s.local.isPreview)

  function lookup({ useSavedPostcode = false } = {}) {
    const params = {
      actionId: action.id,
      lookup: localPostcode,
      useSavedPostcode
    }

    return restClient.get(`/api/target/flows/${flowId}/lookup_decision_makers`, { params })
      .then(({ data }) => {
        setDecisionMakers(data.decisionMakers || [])
        setError(data.error || null)
        setPostcode(useSavedPostcode ? 'saved_postcode' : localPostcode)
        setLoading(false)
      })
  }

  useEffect(() => {
    if (postcodeDetailsPresent && !hasReset) { // only do it the first time
      setLoading(true)
      lookup({ useSavedPostcode: true })
    }
  }, [postcodeDetailsPresent])

  useEffect(() => {
    if (autoLookup) {
      lookup()
    }
  }, [autoLookup])

  const getError = (slug) => {
    if (slug == 'no_decision_makers') {
      return <ActionTextContentField slug='noDecisionMakersFoundMessage' actionId={action.id} wysiwyg={false} />
    }
    if (slug == 'invalid_lookup') {
      return <ActionTextContentField slug='invalidLookupValidationMessage' actionId={action.id} wysiwyg={false} />
    }
    return <ActionTextContentField slug='otherLookupErrorMessage' actionId={action.id} wysiwyg={false} />
  }

  if (decisionMakerSet.lookupKind === 'manual') {
    return <ServerWaitButton primary onClick={lookup}>
      <ActionTextContentField slug='buttonTextNext' wysiwyg={false} actionId={action.id} />
    </ServerWaitButton>
  }

  return <div className="lookup-decision-makers">
    <h3>
      <ActionTextContentField slug='enterYourPostcode' actionId={action.id} wysiwyg={false} />
    </h3>
    <input
      type='text'
      className='postcode'
      placeholder={enterYourPostcodePlaceholder}
      value={localPostcode}
      onChange={(e) => setLocalPostcode(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          lookup()
        }
      }}
    />
    {error && <p className="error">{getError(error)}</p>}
    <ServerWaitButton primary onClick={lookup} disabled={localPostcode.length < 5 && !isPreview}>
      <ActionTextContentField slug='findMyMp' actionId={action.id} wysiwyg={false} />
    </ServerWaitButton>
    {error && error == 'no_decision_makers' && <ServerWaitButton primary onClick={onSkip}>
      <ActionTextContentField slug='skipButtonText' actionId={action.id} wysiwyg={false} />
    </ServerWaitButton>}
  </div >
}
